import request from "@/utils/request";

// 查询设备统计
export function getZxsbs(query) {
  return request({
    url: "/dp/zxsbs",
    method: "get",
    params: query,
  });
}

// 查询年度切割统计
export function getNdQgtj(query) {
  return request({
    url: "/dp/ndqgtj",
    method: "get",
    params: query,
  });
}

// 查询在线设备列表
export function getZxsblb(query) {
  return request({
    url: "/dp/sbzxlb",
    method: "get",
    params: query,
  });
}

// 查询实时切割视频列表
export function getSsqgsplb(query) {
  return request({
    url: "/dp/ssqgsplb",
    method: "get",
    params: query,
  });
}

// 查询获取报警记录详细信息
export function getBjjltj(query) {
  return request({
    url: "/dp/bjjltj",
    method: "get",
    params: query,
  });
}

// 查询获取设备点位信息
export function getSbtj(query) {
  return request({
    url: "/dp/sbtj",
    method: "get",
    params: query,
  });
}

// 检查是否有设备操作权限
export function getRoot(query) {
  return request({
    url: "/dp/sb/check_perm",
    method: "get",
    params: query,
  });
}
